import styled from 'styled-components';
import FONTS from '../../style/fonts';

import {
  TextInputColors,
  TextInputShapes,
  WrapperProps,
  BorderRadius,
} from './textInput.types';

const retrieveColorTheme = (style: string, prop: string): string => TextInputColors[style][prop];

export const styledIcons = styled.div`
    position: absolute;
    width: 15px;
    height: 15px;
    z-index:1;
    &.left {
        left: 8px;
    }
`;

export const styledButtonIcons = styled.button`
    position: absolute;
    border: 0;
    background-color: ${({theme}) => retrieveColorTheme(theme, 'base') };
    cursor: pointer;
    &.right{
        right: 8px;
    }
`;

export const styledTextInput = styled.div`
    display: flex;
    height: 100%;
    position: relative;
    align-items: center;
    input {
        position: relative;
        font-size: 15px;
        line-height: 32px;
        color: ${({theme}) => retrieveColorTheme(theme, 'icon') };
        font-weight: 400;
        height: 32px;
        padding: 0 8px;
        width: 100%;
        background-color: ${({theme}) => retrieveColorTheme(theme, 'base') };
        border-radius: ${({$shape}: WrapperProps) => $shape === TextInputShapes.PILL ? BorderRadius.FULL : BorderRadius.DEFAULT};
        border: 1px solid ${({theme}) => retrieveColorTheme(theme, 'border') };
        font-family: ${FONTS.primaryFont};
        ::-ms-clear { display: none; }
        ::-webkit-search-decoration,
        ::-webkit-search-cancel-button,
        ::-webkit-search-results-button,
        ::-webkit-search-results-decoration {
            display: none;
        }
        ::placeholder {
            color: ${({theme}) => retrieveColorTheme(theme, 'text') };
        }
        &.right {
            padding-right: 32px;
        }
        &.left {
            padding-left: 32px;
        }

        &[type='search'] {
            height: 32px;
            -webkit-appearance: none;
        }

        &:focus {
            outline: none;
        }
    }
`;
